module.exports = __webpack_public_path__ + "img/switzerland-leukaemia-female.f8f6b488.png";